import { Box } from '@mui/material';
import { ToolCallData } from '@shared/services/conversationApiService/types';
import { ToolCallCard } from '@widgets/ToolCallCard/ToolCallCard';
import { useStyles } from './styles';

interface ToolCallRowProps {
  toolCall: ToolCallData;
}

export const ToolCallRow = ({ toolCall }: ToolCallRowProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.toolCallRow}>
      <ToolCallCard toolCall={toolCall} />
    </Box>
  );
};
